import { useEffect } from "react";
import DOMPurify from "dompurify";
import LastUpdated from "../../../common/partials/LastUpdated/LastUpdated";

import ContentCard from "common/components/ContentCard";

import BillingGroupPricingTables from "./BillingGroupPricingTables";
import {toUpperCaseSentence} from "../../../common/utils/ToUpperCaseSentence";

export default function BillingGroupDetailInfo({ billingGroupDetail, basePrice, pricingTables, editButton, deleteButton, ...props }) {

    useEffect(() => {

    }, [props])

    const startDate = billingGroupDetail.contract_start_date === "0000-00-00"
    || billingGroupDetail.contract_start_date === null
        ? ""
        : billingGroupDetail.contract_start_date;

    return (
        <>
            <ContentCard
                headerContent={"Billing Group"}
                hasCRUDButtons={!!props.canEdit}
                hasAddButton={false}
                hasCloneButton={false}
                hasDeleteButton={true}
                onClickEdit={editButton}
                onClickDelete={deleteButton}
            >
                <dl className={"description-list"} style={{ alignItems: 'start', paddingBottom: '5px' }}>
                    <div>
                        <dt> <b> Description: </b> </dt>
                        <dd dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(billingGroupDetail.description)}}></dd>
                    </div>
                </dl>
                <dl className={"description-list"} style={{ alignItems: 'start', paddingTop: '5px' }}>
                    <div className={"break"}></div>
                    <div style={{ flexFlow: 'column', marginRight: 30 }}>
                        <dt> <b> Details: </b> </dt>
                        <div>
                            <dt style={{minWidth: 170}}>Contract Start Date:</dt>
                            <dd> <LastUpdated lastUpdated={startDate} />  </dd>
                        </div>
                        <div>
                            <dt style={{minWidth: 170}}>Contract Term (months):</dt>
                            <dd>{billingGroupDetail.contract_term}</dd>
                        </div>
                        <div>
                            <dt style={{minWidth: 170}}> Notification Period (days):</dt>
                            <dd> {billingGroupDetail.cancel_days_notice} </dd>
                        </div>
                        <div>
                            <dt style={{minWidth: 170}}> Monthly Minimum Volume:</dt>
                            <dd> {billingGroupDetail.monthly_aggregate_volume} </dd>
                        </div>
                        <div>
                            <dt style={{minWidth: 150}}> Auto Renew: </dt>
                            <dd> {billingGroupDetail.auto_renew === true ? "True" : "False"} </dd>
                        </div>
                    </div>
                    <div style={{ flexFlow: 'column' }}>
                            <dt> <b> Pricing Information: </b> </dt>
                            <div>
                                <dt style={{minWidth: 150}}> Pricing Per:</dt>
                                <dd> {toUpperCaseSentence(billingGroupDetail.price_model)} </dd>
                            </div>
                            <div>
                                <dt style={{minWidth: 150}}> Currency: </dt>
                                <dd> {billingGroupDetail.currency} </dd>
                            </div>
                            <div>
                                <dt style={{minWidth: 150}}> Billing Period (months): </dt>
                                <dd> {billingGroupDetail.billing_period} </dd>
                            </div>
                            <div>
                                <dt style={{minWidth: 150}}> Aggregation Type: </dt>
                                <dd> {billingGroupDetail.volume_aggregation_type} </dd>
                            </div>
                        <div>
                            <dt style={{minWidth: 150}}> Base Price: </dt>
                            <dd> {basePrice}</dd>
                        </div>
                        </div>
                </dl>

                <BillingGroupPricingTables
                    billingGroupDetail={billingGroupDetail}
                    billingGroupID={billingGroupDetail?.id}
                    pricingTables={pricingTables}
                    {...props}
                />

            </ContentCard>
        </>
    );
}
